<div class="main-content">

    <section class="top-content">
        <div class="top-contents-text">
            <div class="back-link font-inter" (click)="goBack()">
                ← Back to Home
            </div>
            <h1 class="page-title">Privacy Policy</h1>
            <p class="page-subtitle font-inter">
                Your privacy matters to us. Learn how FunFigz protects your data.
            </p>
            <p class="page-meta font-inter">
                Last Updated: January 2024
                <span class="dot">•</span>
                Effective Immediately
            </p>
        </div>
    </section>

    <section class="privacy-body">

        <div class="privacy-card">

            <div class="card-header">
                <div class="card-icon privacy">
                    <mat-icon [svgIcon]="'shield'"></mat-icon>
                </div>
                <div class="card-heading">
                    <h2 class="card-title">Privacy Policy Introduction</h2>
                    <p class="card-subtitle font-inter">
                        Understanding our commitment to your privacy
                    </p>
                </div>
            </div>
            <!-- Content -->
            <div class="card-content font-inter">
                <p>
                    Welcome to <span>FunFigz</span>, a brand owned and operated by
                    <strong><span>UDM Global Solution Private Limited</span></strong>.
                    We are committed to safeguarding your privacy and ensuring that your
                    personal information is protected with the utmost care and responsibility.
                </p>

                <p>
                    This Privacy Policy explains how we collect, use, share, and protect your
                    personal information when you use our platform. We believe in transparency
                    and want you to understand exactly how your data is handled.
                </p>

                <p>
                    By accessing or using FunFigz, you consent to the collection and use of your
                    information as described in this Privacy Policy.
                </p>
            </div>


            <!-- Alert -->
            <div class="policy-alert">
                <mat-icon [svgIcon]="'alert'"></mat-icon>
                <p class="font-inter">
                    By continuing to use our services, you acknowledge that you have read,
                    understood, and agree to be bound by this Privacy Policy.
                </p>
            </div>

        </div>


        <div class="privacy-card" *ngFor="let section of privacySections"  [ngClass]="{ 'privacy-card--contact': section.variant === 'contact' }">

            <!-- Card Header -->
            <div class="card-header">
                
            <div class="card-icon" [ngClass]="section.icon">
                    <mat-icon [svgIcon]="section.icon" ></mat-icon>
            </div>
                

                <div class="card-heading">
                    <h2 class="card-title">{{ section.title }}</h2>
                    <p class="card-subtitle font-inter">
                        {{ section.subtitle }}
                    </p>
                </div>
            </div>
            <!-- Section description -->
            <p class="section-description font-inter"  *ngIf="section.variant!= 'contact'">
                {{ section.description }}
            </p>


            <!-- Highlight message -->
            <div class="highlight-box font-inter" *ngIf="section.highlight">
                <mat-icon svgIcon="check"></mat-icon>
                <p>{{ section.highlight }}</p>
            </div>

            <!-- ✅ GRIEVANCE SECTION -->
            <div class="grievance-box" *ngIf="section.variant === 'grievance'">

               

                <h4>{{ section.checklistTitle }}</h4>

                <ul>
                <li  class="font-inter" *ngFor="let item of section.checklist">
                    <mat-icon svgIcon="tick"></mat-icon>
                    {{ item }}
                </li>
                </ul>

                <!-- Contact card -->
                <div class="contact-card">
                <mat-icon svgIcon="email"></mat-icon>

                <div>
                    <h5>{{ section.contact?.title }}</h5>
                    <h3>
                    {{ section.contact?.email }}
                    </h3>
                    <p class="font-inter">{{ section.contact?.note }}</p>
                </div>
                </div>

            </div>
            <!-- Inner list -->
            <div class="info-list" *ngIf="section.variant!= 'contact'"
            [ngClass]="{'info-list--blue': section.variant === 'blue',
                'info-list--grid': section.title === 'Why Do We Need Your Information',
                'info-list--borderBox': section.title === 'Sharing of Your Information',
                'info-item--background': section.title === 'Choices You Can Make',
                'info-list--security': section.title === 'Threat to Your Information (Security)',
                'info-list--policy': section.variant === 'policy'

            }"
            >
                <div
                    class="info-item"
                    *ngFor="let item of section.items"
                    [ngClass]="'security-' + item.color"
                >
                    <mat-icon [svgIcon]="item.icon" class="icons" *ngIf="section.variant !== 'security' && section.variant !== 'information'"></mat-icon>
                    <mat-icon [svgIcon]="item.icon" class="security-icons" *ngIf="section.variant == 'security' || section.variant == 'information'"></mat-icon>
                    
                    <div class="info-text">
                        <h4>{{ item.title }}</h4>
                        <p>{{ item.description }}</p>
                    </div>
                </div>
            </div>
            <!-- Section warning (security / grievance) -->
            <div class="section-warning font-inter" *ngIf="section.warning"
                [ngClass]="{
                    'warning-security': section.variant === 'security',
                    'warning-grievance': section.variant === 'grievance'
                }"
                >
                <mat-icon
                    [svgIcon]="section.variant === 'grievance' ? 'alert' : 'warning'"
                    class="warning-icon"
                ></mat-icon>

                <p>{{ section.warning }}</p>
            </div>

            <!-- CONTACT INFORMATION SECTION -->
            <div class="contact-box" *ngIf="section.variant === 'contact'">
                <h3>{{ section.contactInfo!.company }}</h3>

                <!-- Rows -->
                <div class="contact-row"

                    *ngFor="let row of section.contactInfo!.rows">

                    <mat-icon [svgIcon]="row.icon" class="contact-icon"></mat-icon>

                    <div class="contact-info">
                        <span class="font-inter">{{ row.label }}:</span>

                        <!-- Normal text -->
                        <p *ngIf="!row.isLink" style="white-space: pre-line;">
                            {{ row.value }}
                        </p>

                        <!-- Link -->
                        <p class="value font-inter" *ngIf="row.isLink">
                            {{ row.value }}
                        </p>
                    </div>

                </div>
                <hr class="contact-separator" />
                <!-- Footer note -->
                <div class="contact-footer">
                    <mat-icon svgIcon="check"></mat-icon>
                    <p class="font-inter">{{ section.contactInfo!.footerNote }}</p>
                </div>
            </div>
        </div>
        <div class="bottom-content">

            <div class="bottom-text-content">

                <mat-icon svgIcon="heart"></mat-icon>

                <h3>Thank You for Trusting FunFigz</h3>

                <p class="font-inter">Your privacy and security are at the heart of everything we do. We're committed to providing you with a safe, transparent, and enjoyable shopping experience. If you have any questions or concerns, please don't hesitate to reach out.</p>

            </div>

        </div>
    </section>



</div>